// Backlog.js
import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { formOptionsBacklog } from "./constants";

export const Backlog = ({ formData, handleChange, errors }) => {
  const handleBacklogChange = (e, index) => {
    const { name, value } = e.target;
    const newBacklog = Array.isArray(formData.backlog) ? [...formData.backlog] : [];
    newBacklog[index][name] = value;
    handleChange({
      target: {
        name: "backlog",
        value: newBacklog,
      },
    });
  };

  const handleManualSwitch = (index) => {
    const newBacklog = Array.isArray(formData.backlog) ? [...formData.backlog] : [];
    newBacklog[index].isPekerjaanManual = !newBacklog[index].isPekerjaanManual;
    newBacklog[index].pekerjaan = "";
    handleChange({
      target: {
        name: "backlog",
        value: newBacklog,
      },
    });
  };

  // Jumlah backlog sudah ditentukan oleh jumlahKK, tidak perlu tombol tambah/hapus

  return (
    <>
    {(Array.isArray(formData.backlog) ? formData.backlog : []).map((item, i) => (
        <div key={i} className="border p-3 mb-3 rounded">
          <h5>Kartu Keluarga #{i + 1}</h5>

          <FormGroup>
            <Label for={`namaKK-${i}`}>Nama KK (Data Backlog)</Label>
            <Input
              type="text"
              name="namaKK"
              id={`namaKK-${i}`}
              value={item.namaKK}
              onChange={(e) => handleBacklogChange(e, i)}
              className={errors.backlog?.[i]?.namaKK ? "is-invalid" : ""}
            />
            {errors.backlog?.[i]?.namaKK && (
              <div className="invalid-feedback">{errors.backlog[i].namaKK}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for={`nomorKK-${i}`}>Nomor KK (Data Backlog)</Label>
            <Input
              type="text"
              name="nomorKK"
              id={`nomorKK-${i}`}
              value={item.nomorKK}
              onChange={(e) => handleBacklogChange(e, i)}
              className={errors.backlog?.[i]?.nomorKK ? "is-invalid" : ""}
            />
            {errors.backlog?.[i]?.nomorKK && (
              <div className="invalid-feedback">{errors.backlog[i].nomorKK}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for={`alamat-${i}`}>Alamat (Data Backlog)</Label>
            <Input
              type="text"
              name="alamat"
              id={`alamat-${i}`}
              value={item.alamat}
              onChange={(e) => handleBacklogChange(e, i)}
              className={errors.backlog?.[i]?.alamat ? "is-invalid" : ""}
            />
            {errors.backlog?.[i]?.alamat && (
              <div className="invalid-feedback">{errors.backlog[i].alamat}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for={`pekerjaan-${i}`}>Pekerjaan (Data Backlog)</Label>
            {!item.isPekerjaanManual ? (
              <Input
                type="select"
                name="pekerjaan"
                id={`pekerjaan-${i}`}
                value={item.pekerjaan}
                onChange={(e) => handleBacklogChange(e, i)}
              >
                <option value="">Pilih</option>
                {formOptionsBacklog.pekerjaan.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            ) : (
              <div>
                <Input
                  type="text"
                  name="pekerjaan"
                  id={`pekerjaan-${i}`}
                  value={item.pekerjaan}
                  onChange={(e) => handleBacklogChange(e, i)}
                  placeholder="Masukkan Pekerjaan"
                />
              </div>
            )}
            <Button
              color="link"
              size="sm"
              onClick={() => handleManualSwitch(i)}
            >
              {item.isPekerjaanManual ? "Kembali ke pilihan" : "Input manual"}
            </Button>
          </FormGroup>

          <FormGroup>
            <Label for={`penghasilan-${i}`}>Penghasilan (Data Backlog)</Label>
            <Input
              type="text"
              name="penghasilan"
              id={`penghasilan-${i}`}
              value={item.penghasilan}
              onChange={(e) => handleBacklogChange(e, i)}
            />
          </FormGroup>

          <FormGroup>
            <Label for={`jumlahAnggotaKK-${i}`}>Jumlah Anggota KK (Data Backlog)</Label>
            <Input
              type="number"
              name="jumlahAnggotaKK"
              id={`jumlahAnggotaKK-${i}`}
              value={item.jumlahAnggotaKK}
              onChange={(e) => handleBacklogChange(e, i)}
            />
          </FormGroup>

          <FormGroup>
            <Label for={`KepemilikanTanah-${i}`}>
              Status Kepemilikan Tanah
            </Label>
            <Input
              type="select"
              name="kepemilikanTanah"
              id={`kepemilikanTanah-${i}`}
              value={item.kepemilikanTanah}
              onChange={(e) => handleBacklogChange(e, i)}
            >
              <option value="">Pilih</option>
              {formOptionsBacklog.statusKepemilikanTanah.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for={`usiaPernikahan-${i}`}>Usia Pernikahan (Data Backlog)</Label>
            <Input
              type="number"
              name="usiaPernikahan"
              id={`usiaPernikahan-${i}`}
              value={item.usiaPernikahan}
              onChange={(e) => handleBacklogChange(e, i)}
            />
          </FormGroup>

        </div>
      )) || null}
    </>
  );
};
